export default "__VITE_ASSET__e203b2fb__"